import {reducer} from './reducer';
import {loadBlogs} from './actions';

export {loadBlogs};
export default reducer;